import { connect } from 'react-redux';

import { InviteeWithTranslations as Invitee } from './invitee.component';
import { ITranslationProps } from 'types/translation';
import { IGetInviteInfo } from '@sitegen/common/classes/friends-referral-api';
import { DEFAULT_STAT_VALUE } from './invitee.constants';
import { State } from 'widgets/friends-referral/root/root.reducers';
import { DATA_FORMAT } from '@sitegen/common/constants';

export interface IInviteeStoreProps {
    readonly invitationInfo: IGetInviteInfo;
    readonly paramThreshold: number;
    readonly paramValue: string;
    readonly inviteeRewardImageSrc?: string;
    readonly statsFormatting: DATA_FORMAT;
}

const mapStateToProps = (state: State): IInviteeStoreProps => {
    const paramName = state.friendsReferral.campaignInfo?.conversion?.paramName ?? '';
    const paramValue = state.friendsReferral.playerStats?.[paramName] ?? DEFAULT_STAT_VALUE;
    const inviteeRewardImageSrc = state.config.friendsReferral?.inviteeRewardImageSrc;

    return {
        invitationInfo: state.friendsReferral.invitationInfo || {} as IGetInviteInfo,
        paramThreshold: state.friendsReferral.campaignInfo!.conversion.paramThreshold,
        paramValue,
        statsFormatting: state.config.friendsReferral?.dataFormat ?? DATA_FORMAT.NUMBER,
        inviteeRewardImageSrc
    };
};

export type IInviteeProps = IInviteeStoreProps & ITranslationProps;

export default connect(mapStateToProps)(Invitee);
